import typeCheck from 'common/util/typeCheck';
import {
  SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_BUYERS_AGENT,
  SR_API_ACTION_HOUSEHOLD_GET_BY_USER_ID,
} from 'api/actionTypes';

export default async function updateBuyersAgent({ state, apiClient }, {
  userId,
  listingId,
  householdId,
  updates,
}) {
  if (userId && !householdId) {
    const currentHousehold = await apiClient.post(SR_API_ACTION_HOUSEHOLD_GET_BY_USER_ID, {
      userId,
    });
    householdId = currentHousehold.id;
  }
  typeCheck('householdId::PositiveNumber', householdId);
  await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_LISTING_UPDATE_BUYERS_AGENT,
    state: state,
    payload: {
      householdId,
      listingId,
      updates,
    },
  });
}
